export const it = {
  site: 'Poste Italiane site',
  login_description: 'Esegui il login per accedere all\'interfaccia Amazon Connect ed iniziare a lavorare i tuoi ticket.',
  communications: 'Comunicazioni',
  agent_popup: {
    detail: 'Dettaglio Agente',
    username: 'Username',
    name: 'Nome',
    agent_id: 'ID Agente',
    profile: 'Profilo',
    state: 'Stato',
    my_profile: 'Il mio profilo',
    polo: 'Polo',
    login: 'Accedi',
    logout: 'Esci'
  },
  call_informations: {
    get_data: 'Frazionario/PDL',
    office_info: 'Info Ufficio',
    caller_info: 'Caller',
    pdl_info: 'Postazione',
    caller: 'Chiamante',
    serial_number: 'Matricola',
    user_id: 'UserId',
    queue: 'Coda',
    cluster: 'Cluster',
    queue_id: 'Coda Id',
    teams: 'Apri su Teams',
    email: 'Invia Email',
    sms: 'Invia Sms',
    call_number: 'Chiamate ricevute da questo numero',
    system_alert: 'Spazio di archiviazione utilizzato maggiore del'
  },
  pdl_search: {
    fractional: 'Frazionario',
    username: 'Username',
    pdl: 'PDL',
    get_data: 'get data',
    caller_id: 'CallerId',
    postponed: 'Posposti',
    service_area: 'Supporto Tecnico'
  },
  communication: {
    pp: 'Problem Padre',
    urgent: 'Urgente',
    normal: 'Normale'
  },
  communication_buttons: {
    open: 'apri',
    close: 'chiudi'
  },
  audio_chat: {
    start: 'Ho avviato una chiamata audio, da questo momento possiamo utilizzare cuffia e microfono per comunicare.',
    start_screenshare_request: 'Ho avviato la condivisione dello schermo. Abilitando l\'icona del microfono, puoi anche avviare una comunicazione audio utilizzando le cuffie in dotazione.',
    chat_start_screenshare_request: 'Ho avviato la condivisione dello schermo.',
    enter: 'Sono entrato nella sessione audio',
    screenshare_request: 'Vorrei iniziare a condividere lo schermo',
    screen_share_start: 'Ho iniziato a condividere lo schermo',
    screen_share_stop: 'Ho terminato la condivisione dello schermo',
    recording_accepted: 'Si do il consenso.',
    recording_start: 'Registrazione iniziata',
    recording_end: 'Registrazione terminata',
    chat_escalation_start: 'Stiamo trasferendo la chat, rimani in attesa',
    screen_share: 'Condivisione Schermo',
    ticket_number: 'Il numero del ticket associato a questa conversazione è'
  },
  audio_chat_buttons: {
    start: 'Avvia audio chat',
    microphone: 'Microfono On',
    microphone_off: 'Microfono Off',
    recording: 'Avvia Registrazione',
    recording_off: 'Ferma Registrazione',
    screen_share: 'Schermo On',
    screen_share_off: 'Schermo Off'
  },
  call_operation_buttons: {
    funnel: 'crea funnel',
    incident: 'crea incident',
    request: 'crea request',
    line_drop: 'caduta linea',
    solicit: 'sollecito',
    postpone: 'MODIFICA RINVIO',
    postponesnow: 'posponi ticket',
    unpostpone: 'Presa in carico',
    openemail: 'Apri tab email'
  },
  email_form: {
    disabled: 'Form email disabilitato',
    current_ticket: 'Numero Ticket Corrente',
    email_sent: 'Email inviata con successo!',
    email_failed: 'Invio email fallito. Riprova.',
    to: 'A',
    cc: 'CC',
    subject: 'Oggetto',
    email_thread: 'Thread Email',
    your_reply: 'La tua risposta',
    reply_placeholder: 'Scrivi qui la tua risposta...',
    send: 'Invia Email',
    sending: 'Invio in corso...',
    start_reply: 'Rispondi',
    open_conversation: 'Apri conversazione',
    no_email_thread: 'Thread email non disponibile',
    to_placeholder: 'destinatario@esempio.com',
    cc_placeholder: 'cc1@esempio.com, cc2@esempio.com',
    subject_placeholder: 'Oggetto email',
    invalid_email: 'Formato email non valido'
  },
  call_agent_metrics: {
    managed: 'Contatti gestiti',
    lost: 'Contatti persi',
    talk_time: 'Tempo medio per contatto'
  },
  tabs_management: {
    asset: 'info asset',
    ticket: 'info ticket',
    itca: 'info itca',
    recording: 'recording',
    dynamic_buttons: 'pulsanti dinamici',
    links: 'link web',
    command_console: 'console comandi',
    service_now_search: 'ricerca su service now',
    service_now_ticket: 'Ticket service now',
    funnel: 'Integrazione Portale Funnel'
  },
  traffic_light: {
    'green-9': 'Code Libere',
    'orange-8': 'Code Sostenute',
    'red-8': 'Code Sature',
    'grey-7': 'caricamento'
  },
  agent_toggle_state: {
    on: 'Clicca per andare online',
    off: 'Clicca per andare offline'
  },
  assets_table_headers: {
    type: 'Tipo di Asset',
    brand: 'Marca',
    serial_number: 'Numero di Serie',
    pt_number: 'PT Number',
    last_state: 'Ultimo Stato'
  },
  tickets_table_headers: {
    number: 'Numero del Ticket',
    service: 'Servizio',
    area: 'Area',
    description: 'Breve Descrizione',
    group: 'Gruppo',
    date: 'Data di Apertura',
    state: 'Stato'
  },
  recording_table_headers: {
    username: 'Username',
    fractional: 'Frazionario',
    pdl: 'PDL',
    link: 'Link',
    date: 'Data'
  }
};
